export default "__VITE_ASSET__4a49ffeb__$_?component__"